export default {"src":"/_next/static/media/arrow-up-right.d36ab0ec.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};